export enum UserRole {
    ADMIN = 'Admin',
    COMMERCIALS = 'Commercials',
    CUSTOMS = 'Customs',
    CUSTOMER_SUPPORT = 'CustomerSupport',
    E_COMMERCE = 'ECommerce',
    EXPORT_CLASSIFICATION = 'ExportClassification',
    FACTORY_DATA_MANAGER = 'FactoryDataManager',
    KNOWLEDGE_MANAGER = 'KnowledgeManager',
    LOGISTICS = 'Logistics',
    PRODUCT_LIFECYCLE_MANAGER = 'ProductLifecycleManager'
}
